module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-t1"
  }, [_vm._v("TAKE THE FIRST SHOT")]), _vm._v(" "), _c('p', {
    staticClass: "copy-t2"
  }, [_vm._v("Strategies to Fire You Up and Change Your Life")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("© 2021 Peggy Caruso")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published in New York, New York, by Morgan James Publishing. Morgan James is a trademark of Morgan James, LLC. "), _c('a', {
    attrs: {
      "href": "http://www.MorganJamesPublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesPublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 9781631951398 paperback")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("ISBN 9781631951404 eBook")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Library of Congress Control Number: 2020936627")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_c('span', {
    staticClass: "abold"
  }, [_vm._v("Cover and Interior Design by:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Constellation Book Services")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("Morgan James is a proud partner of Habitat for Humanity Peninsula and Greater Williamsburg. Partners in building since 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("Get involved today! Visit"), _c('br'), _c('a', {
    attrs: {
      "href": "http://MorganJamesPublishing.com/giving-back",
      "target": "_blank"
    }
  }, [_vm._v("MorganJamesPublishing.com/giving-back")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 69
// module chunks = 0